<template>
<div class="main">
    <c-panel title="RELATÓRIO DE PONTO" titleIcon="fas fa-print">

        <el-form label-position="top">
            <el-row :gutter="10">
                <el-col :xs="12" :sm="6" :md="4">
                    <el-form-item label="Mês">
                        <el-select v-model="filtro.mes" style="width: 100%;">
                            <el-option v-for="m in meses" :key="m.value" :label="m.label" :value="m.value"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :xs="12" :sm="4" :md="3">
                    <el-form-item label="Ano">
                        <el-input-number v-model="filtro.ano" :min="2000" :max="2100" :controls="false"
                            style="width: 100%;"></el-input-number>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="14" :md="8">
                    <el-form-item label="Unidade">
                        <el-select v-model="filtro.instituicao_cod" filterable placeholder="Selecione a unidade"
                            :loading="carregandoInstituicoes" style="width: 100%;" @change="getCargos">
                            <el-option v-for="i in instituicoes" :key="i.codigo" :label="i.nome" :value="i.codigo"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :md="5">
                    <el-form-item label="Cargo">
                        <el-select v-model="filtro.cargo" filterable clearable placeholder="Todos os cargos"
                            :loading="carregandoCargos" style="width: 100%;">
                            <el-option v-for="c in cargos" :key="c" :label="c" :value="c"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :md="4">
                    <el-form-item label="Ordenação">
                        <el-select v-model="filtro.ordenar" style="width: 100%;">
                            <el-option label="Nome" value="nome"></el-option>
                            <el-option label="Nr. Registro" value="registro"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row :gutter="10">
                <el-col :xs="24" :sm="14" :md="14">
                    <el-checkbox v-model="filtro.somente_com_lancamento">
                        Listar apenas servidores com lançamento na competência
                    </el-checkbox>
                </el-col>
                <el-col :xs="24" :sm="10" :md="10" class="u-text-right">
                    <el-button type="primary" icon="el-icon-printer" @click="imprimir" :loading="gerando">
                        GERAR RELATÓRIO
                    </el-button>
                </el-col>
            </el-row>
        </el-form>
    </c-panel>
</div>
</template>

<script>
// O relatório sai em PDF pelo backend. Como a rota exige token, o arquivo é
// buscado por axios e aberto numa aba a partir do blob — mesmo padrão das
// carteirinhas e dos demais relatórios do sistema.
export default {
    data: () => ({
        gerando: false,
        carregandoInstituicoes: false,
        carregandoCargos: false,
        instituicoes: [],
        cargos: [],
        filtro: {
            mes: new Date().getMonth() + 1,
            ano: new Date().getFullYear(),
            instituicao_cod: '',
            cargo: '',
            ordenar: 'nome',
            somente_com_lancamento: false
        },
        meses: [
            { value: 1, label: 'Janeiro' }, { value: 2, label: 'Fevereiro' }, { value: 3, label: 'Março' },
            { value: 4, label: 'Abril' }, { value: 5, label: 'Maio' }, { value: 6, label: 'Junho' },
            { value: 7, label: 'Julho' }, { value: 8, label: 'Agosto' }, { value: 9, label: 'Setembro' },
            { value: 10, label: 'Outubro' }, { value: 11, label: 'Novembro' }, { value: 12, label: 'Dezembro' }
        ]
    }),
    mounted () {
        this.getInstituicoes()
        this.getCargos()
    },
    methods: {
        baseUrl () {
            return `${this.$store.state.config.baseUrlApi}/api/folha-ponto`
        },
        erro (e) {
            const msg = e && e.response && e.response.data && e.response.data.throw
                ? e.response.data.throw.msg
                : 'Não foi possível gerar o relatório.'

            window.eventBus.$emit('alert', { msg, type: 'error' })
            this.$store.commit('throwException', e)
        },
        getInstituicoes () {
            this.carregandoInstituicoes = true
            this.$axios.get(`${this.baseUrl()}/instituicoes`, this.$store.getters.getHeaderAuth)
                .then(res => { this.instituicoes = (res.data && res.data.instituicoes) || []; this.carregandoInstituicoes = false })
                .catch(e => { this.carregandoInstituicoes = false; this.erro(e) })
        },
        getCargos () {
            this.filtro.cargo = ''
            this.carregandoCargos = true

            const params = { instituicao_cod: this.filtro.instituicao_cod }

            this.$axios.get(`${this.baseUrl()}/relatorio/cargos`, Object.assign({ params }, this.$store.getters.getHeaderAuth))
                .then(res => { this.cargos = res.data || []; this.carregandoCargos = false })
                .catch(e => { this.carregandoCargos = false; this.erro(e) })
        },
        imprimir () {
            if (!this.filtro.instituicao_cod) {
                window.eventBus.$emit('alert', { msg: 'Selecione a unidade para gerar o relatório.', type: 'warning' })
                return
            }

            this.gerando = true

            this.$axios.post(`${this.baseUrl()}/relatorio/ponto`, this.filtro,
                Object.assign({ responseType: 'blob' }, this.$store.getters.getHeaderAuth))
                .then(res => {
                    this.gerando = false

                    const tipo = (res.headers && res.headers['content-type']) || ''

                    // Erro tratado no backend volta em JSON, mesmo com responseType blob.
                    if (tipo.indexOf('application/json') !== -1) {
                        const leitor = new FileReader()
                        leitor.onload = () => {
                            let msg = 'Não foi possível gerar o relatório.'
                            try {
                                const obj = JSON.parse(leitor.result)
                                if (obj && obj.throw && obj.throw.msg) msg = obj.throw.msg
                            } catch (e) { /* mantém a mensagem padrão */ }
                            window.eventBus.$emit('alert', { msg, type: 'warning' })
                        }
                        leitor.readAsText(res.data)
                        return
                    }

                    const url = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }))
                    window.open(url, '_blank')
                })
                .catch(e => { this.gerando = false; this.erro(e) })
        }
    }
}
</script>
